// ---------------------------------------------------------------------------
// Project palette — colors available for project color selection
// ---------------------------------------------------------------------------
export const PROJECT_COLORS = [
  '#7C3AED', // violet
  '#4F46E5', // indigo
  '#2563EB', // blue
  '#0891B2', // cyan
  '#059669', // emerald
  '#65A30D', // lime
  '#CA8A04', // yellow
  '#EA580C', // orange
  '#DC2626', // red
  '#DB2777', // pink
  '#9333EA', // purple
  '#6B7280', // slate
  '#1D4ED8', // dark blue
  '#0F766E', // teal
  '#15803D', // green
] as const;

// ---------------------------------------------------------------------------
// Chart / status colors — used in donut/pie charts on the Status tab
// ---------------------------------------------------------------------------
export const CHART_COLORS = {
  billable: '#54bd2b',
  nonBillable: '#a5d6a7',
} as const;
